import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import LoadingAdapter from "libs/utils/LoadingAdapter";
import _ from "lodash";
import MasterService from "services/MasterService";

let initialState = { list: {}, exchangeRate: 0 };

export const getMasterData = createAsyncThunk(
  "master/getMasterData",
  async (payload, { getState }) => {
    const defaultParams = {
      CurrencyCode: false,
      smartservice: false,
      nationalityConfig: false,
      genderConfig: false,
      MarittalConfig: true,
      EducationConfig: false,
      AssignmenConfig: false,
      JobPositionConfig: false,
      CountryConfig: false,
      ActivitiesConfig: false,
      OrganiztionTypeConfig: false,
      VisaTypeConfig: false,
    };

    const response = await MasterService.getAllMasterData({
      ...defaultParams,
      ...payload,
    });

    const keys = Object.keys(payload)
      .filter((key) => payload[key])
      .map(_.camelCase);
    return { ...getState().master.list, ..._.pick(response?.results, keys) };
  }
);

export const getExchangeRate = createAsyncThunk(
  "master/getExchangeRate",
  async ({ period, currencyCode }) => {
    const response = await MasterService.getExchangeRate(period, currencyCode);
    return response?.results;
  }
);

const masterSlice = createSlice({
  name: "master",
  initialState: LoadingAdapter.getInitialState(initialState),
  reducers: {
    clearAll: LoadingAdapter.getInitialState(initialState),
    clearAsyncState: LoadingAdapter.clearAsyncState,
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(getMasterData, builder, ["list"], {
      mergePrevStateOnSuccess: true,
    });
    LoadingAdapter.applyAsyncBuilder(getExchangeRate, builder, [
      "exchangeRate",
    ]);
  },
});

export const selectMasterData = (state) => state.master.list;

export default masterSlice.reducer;
